import * as React from "react";
import { forwardRef } from "react";
const SvgRightMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 14, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M2.177 13.044a2.5 2.5 0 0 1-1.01-.218 1.95 1.95 0 0 1-.843-.696A1.9 1.9 0 0 1 0 11.098V1.947C.004 1.58.117 1.22.324.915.53.608.823.367 1.167.219A2.38 2.38 0 0 1 3.622.5l5.666 4.576c.222.173.401.393.525.643a1.82 1.82 0 0 1 0 1.605c-.124.25-.303.47-.525.643l-5.666 4.576a2.32 2.32 0 0 1-1.445.5" }));
const ForwardRef = forwardRef(SvgRightMenu);
export { ForwardRef as ReactComponent };
